import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Dispatch } from '../redux/store';
import { QuoteStatuses, DialogNames, AnalyticsEventKeys } from '../constants';
import currentDate from '../currentDate';

const DeclineQuote = function DeclineQuote(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const onClick = function handleOnClick(): void {
    dispatch.quote.setQuoteStatus(QuoteStatuses.Declined, currentDate());
    dispatch.dialog.setOpenDialog(DialogNames.SendFeedback);
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.DeclineClicked
    });
  };

  return (
    <Button variant='outlined' color='inherit' onClick={onClick}>
      <FormattedMessage id='decline' defaultMessage='Decline' />
    </Button>
  );
};

export default DeclineQuote;
